<div class="container mt-5 mb-5 card p-3" *ngIf="!loading && infoClass">
  <!-- Start Filter -->
  <div class="row">
    <div class="col-md-8">
      <h1 class="primary group-class-title pb-3">
        <i class="fas fa-users"></i> {{ infoClass.name }}
      </h1>
      <p *ngIf="infoClass.lesson_level" class="pt-2"><i class="far fa-hand-point-right"></i><strong> {{ infoClass.lesson.name }}</strong> - {{ infoClass.lesson_level.name }}</p>
      <p *ngIf="!infoClass.lesson_level" class="pt-2"><i class="far fa-hand-point-right"></i><strong> {{ infoClass.lesson.name }}</strong></p>
    </div>
    <div class="col-md-4">
     
      <ng-container *ngIf="!ios">
        <a *ngIf="infoClass.current_user_in==0" class="btn btn-primary float-right " (click)="showPaymentGroupalDialog()"
          ><i class="fas fa-plus-circle"></i> {{ "sing-up-groupal" | translate }}</a
        >
      </ng-container>

      <ng-container *ngIf="ios">
        <a *ngIf="infoClass.current_user_in==0" class="btn btn-primary float-right " (click)="openWordiix()"
          ><i class="fas fa-plus-circle"></i> {{ "sing-up-groupal-web" | translate }}</a
        >
      </ng-container>

      <span *ngIf="infoClass.current_user_in==1"><strong>{{ "already-signed-groupal-class" | translate }} </strong><br>{{ "navigate-control-panel" | translate }} <a class="bold" [routerLink]="['/student/dashboard']">{{ "access" | translate }}</a></span>
     
    </div>
  </div>
  <div class="row mt-4 box-data-class p-3">
    <div class="col-md-3 text-center p-3 separator-info-box">
      <p class="bold pb-2 primary"><i class="far fa-calendar-check"></i> {{ "date" | translate }}</p>
      <span class="data-class">{{ infoClass.date }}</span>
    </div>
    <div class="col-md-3 text-center p-3 separator-info-box">
      <p class="bold pb-2 primary"><i class="far fa-clock"></i> {{ "hour" | translate }}</p>
      <span class="data-class">{{ infoClass.hour }} h.</span>
    </div>
    <div class="col-md-3 text-center p-3 separator-info-box">
      <p class="bold pb-2 primary"><i class="fas fa-stopwatch"></i> {{ "duration" | translate }}</p>
      <span class="data-class">{{ infoClass.duration }} h.</span>
    </div>
    <div class="col-md-3 text-center p-3">
      <p class="bold pb-2 primary"><i class="far fa-flag"></i> {{ "language" | translate }}</p>
      <span class="data-class">{{ infoClass.language.name }}</span>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12">
      <h2 class="pt-3 bold primary">{{ "description" | translate }}</h2>
      <p>
        {{ infoClass.description }}
      </p>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-12">
      <h2 class="pt-3 bold primary">{{ "subject" | translate }}</h2>
      <p *ngIf="infoClass.lesson_level" class="pt-2">{{ infoClass.lesson.name }} - {{ infoClass.lesson_level.name }}</p>
      <p *ngIf="!infoClass.lesson_level" class="pt-2">{{ infoClass.lesson.name }}</p>
    </div>
  </div>

  <div class="row border m-1 pb-3 teacher-box-info">
    <div class="col-md-12 pb-4">
      <h2 class="pt-3 bold primary"><i class="fas fa-chalkboard-teacher"></i> {{ "teacher" | translate }}</h2>
    </div>
    <div class="col-md-6">
      <iframe *ngIf="infoClass.teacher.video_presentation"
      [src]="infoClass.teacher.video_presentation | domSeguro"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      "
      title=""
    ></iframe>
    <div *ngIf="!infoClass.teacher.video_presentation">
      <img src="/assets/img/no-video-background.jpg">

    </div>
      
    </div>
    <div class="col-md-6">
      <div class="row mt-4">
        <div class="col-12 pb-3">
          <img [src]="infoClass.profile_photo_path">
          <p style="font-size: 1.3em;"><strong>{{ infoClass.teacher.fullname }}</strong> <a [routerLink]="'/search/teacher/'+infoClass.user_id+'/'+infoClass.lesson.id">
            <i class="fas fa-external-link-alt ml-2 text-grey" title="Ver ficha del profesor"></i></a>
          </p>

          <p class="mt-4"><span class="primary bold">{{ "speak" | translate }}: </span> 
            <span *ngFor="let talk of infoClass.teacher.languages">
             - {{talk.language.name}} </span>.</p>
          <p>
          <span class="primary bold">{{ "nationality" | translate }}:</span> {{ infoClass.teacher.country.name_es }}</p>
          <p class="mt-4"><span class="primary bold">{{ "teach" | translate }}:</span> </p>
          
              <span *ngFor="let teacher_lesson of teacher_lessons" class="pl-2 float-left">
                <i class="fas fa-book subjects-icons" *ngIf="teacher_lesson.type=='subject'" title="Materia escolar"></i>
                <i class="fas fa-globe-europe subjects-icons" *ngIf="teacher_lesson.type=='language'" title="Idioma"></i>
                <i class="fas fa-bookmark subjects-icons" *ngIf="teacher_lesson.type=='other'" title="Otras actividades"></i>
                {{ teacher_lesson.name }}
              </span>
 
        </div>
        
      </div>
    </div>  
    <div class="col-md-12 mt-4">
      
          <p><span class="primary bold">{{ "description" | translate }}:</span></p>
        <p>{{ infoClass.teacher.description }}</p>
    
    </div>
  </div>

  <div class="row mt-5 p-3">
    <div class="col-md-6">
      <h2 class=" bold primary pb-3">{{ "price" | translate }}</h2>
      <div class="price">{{ infoClass.price | currency:'EUR':true }}</div>
      <div class="small mt-2">{{ "price-by-student" | translate }}</div>
    </div>
    <div class="col-md-6 p-3">
      <h2 class=" bold primary pb-3">{{ "availability" | translate }}</h2>
      <div  class="price">{{ infoClass.freePlaces }}</div>
    </div>
  </div>

  <div class="row pt-3 mt-5 border-top">
    <div class="col-md-6 pt-3">
      <a class="btn btn-secondary" [routerLink]="['/student/group-classes']"
        ><i class="far fa-arrow-alt-circle-left"></i> {{ "back" | translate }}</a
      >
    </div>
    <div class="col-md-6 pt-3 mb-5">
      <ng-container *ngIf="!ios">
          <a *ngIf="infoClass.current_user_in==0" class="btn btn-primary float-right " (click)="showPaymentGroupalDialog()"
          ><i class="fas fa-plus-circle"></i> {{ "sing-up-groupal" | translate }}</a
        >
      </ng-container>
      <ng-container *ngIf="!ios">
          <a *ngIf="infoClass.current_user_in==0" class="btn btn-primary float-right " (click)="openWordiix()"
          ><i class="fas fa-plus-circle"></i> {{ "sing-up-groupal-web" | translate }}</a
        >
      </ng-container>
    <span *ngIf="infoClass.current_user_in==1"><strong>{{ "already-signed-groupal-class" | translate }} </strong><br>{{ "navigate-control-panel" | translate }} <a class="bold" [routerLink]="['/student/dashboard']">{{ "access" | translate }}</a></span>
    </div>
  </div>
  

</div>